// KPI Period Routes Configuration

import { PeriodManagement } from './components';
import { PERIOD_ROUTE_ID } from './common';

export const kpiPeriodRoutes = {
  [PERIOD_ROUTE_ID]: () => <PeriodManagement />,
};

export default kpiPeriodRoutes;
